import { IModel, Model, ModelRecord } from "@common/models/Model";

export interface IVisitTag extends IModel {
	name: string; // "9:56 AM";
	sortOrder: number; // 380;
	visitTagId: number; // 616;
}

export class VisitTagModel extends Model implements ModelRecord<IVisitTag> {
	name: string; // "9:56 AM";
	sortOrder: number; // 380;
	visitTagId: number; // 616;

	constructor(params: Partial<IVisitTag>) {
		super(params);
		this.name = _.defaultTo(params.name, "");
		this.rowVersion = _.defaultTo(params.rowVersion, "");
		this.sortOrder = _.defaultTo(params.sortOrder, 0);
		this.visitTagId = _.defaultTo(params.visitTagId, 0);
	}
}
